import { render, staticRenderFns } from "./DelegateVC.vue?vue&type=template&id=ec73c38e&"
import script from "./DelegateVC.vue?vue&type=script&lang=js&"
export * from "./DelegateVC.vue?vue&type=script&lang=js&"
import style0 from "./DelegateVC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports